import React, { useState, useEffect, useContext } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import "./loginform.css";
import SglContext from "../SglContext";
import { useNavigate } from 'react-router-dom';


export default function Loginform() {
  const [username, setUsername] = useState(localStorage.getItem("username"));
  const [passowrd, setPassword] = useState("");
  const [showLoginForm, setShowLoginForm] = useState(true);
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState({});
  const [email, setEmail] = useState("");
  const [login_id, setLoginId] = useState("");
  const [secret, setSecret] = useState("");
  const [company_name, setCompanyName] = useState("");
  const [date, setDate] = useState(new Date());
  const Sgl = useContext(SglContext)
  const navigate = useNavigate();

  const auth_url = Sgl.nestApiUrl + "/auth/login";
  const logout_url = Sgl.nestApiUrl + "/auth/logout";
  const sgl_webservice_resend_confirmation =
    Sgl.sglApiUrl + "/iphone.php/webservice/ResendConfirmation";
  const sgl_webservice_login_error_log =
    Sgl.sglApiUrl + "/iphone.php/webservice/LoginErrorLog";

  let css = '.sgl-plugin-page #sgl-content-wrapper {padding-bottom: 20px;max-width: 600px;margin: 0px;}'
  css += '.sgl-plugin-page .credit-text {float: none !important;text-align: center;}'
  css += '.sgl-plugin-page .copyright-text {text-align: center;}'

  useEffect(() => {
    Sgl.getUser();
    Sgl.reportToGA('/sgl-wp-plugin/' + Sgl.company_urlpath + '/login');
    Sgl.reportToFB('/sgl-wp-plugin/' + Sgl.company_urlpath + '/login');
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    sgl_plugin_form.style.display = "block";
    let username = localStorage.getItem("username");
    if (username) {
      setUsername(username);
    }

    var timer = setInterval(() => setDate(new Date()), 1000);
    clearInterval(timer);
    if (Sgl.current_user && Sgl.current_user != null) {
      setShowLoginForm(false);
      setUserData(Sgl.current_user);
    } else {
      setShowLoginForm(true);
      setLoading(false);
    }
  }, []);

  function login(e) {
    setLoading(true);
    let username = document.getElementById("username").value;
    let password = document.getElementById("password").value;
    let remember_me = document.getElementById("remember_me").checked
      ? "yes"
      : "no";
    authenticateUser(username, password, remember_me);
  }
  function _handleLoginKeyPress(e) {
    if (e.key === "Enter") {
      setLoading(true);
      let username = document.getElementById("username").value;
      let password = document.getElementById("password").value;
      let remember_me = document.getElementById("remember_me").checked
        ? "yes"
        : "no";
      authenticateUser(username, password, remember_me);
    }
  }

  function logout(e) {
    terminateSession();
  }

  function authenticateUser(username, password, remember_me) {
    // const instance = axios.create({
    //   withCredentials: true
    // })
    // axios.defaults.withCredentials = true;
    let login_errors = document.getElementById("login_errors");
    let login_button = document.getElementById("login_button");
    let confirmation_error = document.getElementById('confirmation_error')
    let login_loader = document.getElementsByClassName("login-loader");
    login_loader = login_loader[0];

    confirmation_error.style.display = "none";
    login_button.style.display = "none";
    login_loader.style.display = "block";

    login_errors.innerHTML = "";
    axios
      .post(
        auth_url,
        {
          username: username,
          password: password,
          remember_me: remember_me,
          company_id: Sgl.company_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then(
        (response) => {
          // localStorage.setItem("login_referrer", document.referrer);
          login_button.style.display = "inline-block";
          login_loader.style.display = "none";

          setLoading(false);
          if (response.data.access_token) {
            localStorage.setItem("access_token", response.data.access_token);
            localStorage.setItem("username", username);
            localStorage.setItem("userTeams", JSON.stringify(response.data.user.userTeams));
            const currentTeamId = localStorage.getItem("currentTeamId")
            const ownedTeam = response.data.user.userTeams?.find(team => team.isOwner);
            const selectedTeam = response.data.user.userTeams?.find(team => team.teamId === currentTeamId || team.teamId == currentTeamId);
            if (Sgl.setCurrentTeamId) {
              Sgl.setCurrentTeamId(selectedTeam?.teamId || ownedTeam?.teamId || 'personal');
            }
            Sgl.setVerificationStatus(response.data.verification_status);
            Sgl.setPendingVerifyUserAction(response.data.pendingVerifyUserAction);
            Sgl.setPendingUserOnboardAction(response.data.pendingUserOnboardAction);
            Sgl.loginOnSGL( remember_me , response.data.update_password, response.data.verify_login, response.data.verification_status, response.data.pendingVerifyUserAction, response.data.pendingUserOnboardAction);
          }
        },
        (error) => {
          login_button.style.display = "inline-block";
          login_loader.style.display = "none";
          setLoading(false);

          if (error.response) {
            if (error.response.data.statusCode == 401) {
              let message_array = error.response.data.message.split("___");
              let flag = message_array[0];
              if (flag == "is_invalid_user" || flag == "Unauthorized") {
                login_error_log(username, password);
                login_errors.innerHTML = "Invalid email address or password.";
              } else if (flag == "is_inactive") {
                login_error_log(username);
                login_errors.innerHTML =
                  "Your account is currently inactive. Please contact support.";
              } else if (flag == "is_pending_registration") {
                login_error_log(username);

                setEmail(message_array[1]);

                var link = document.createElement("a");
                var span = document.createElement("span");

                link.innerHTML = "resend confirmation email.";
                link.setAttribute("href", "javascript:void(0)");
                link.onclick = { resendConfirmation };

                span.innerHTML =
                  "Your registration is not confirmed. Click to ";
                span.appendChild(link);
                confirmation_error.style.display = "block";
                // login_errors.appendChild(span);
              } else if (flag == "is_bad_email") {
                login_error_log(username);

                setLoginId(message_array[1]);
                setSecret(message_array[2]);

                sendVerificationEmail(message_array[1], message_array[2]);
              }
            } else {
              login_error_log(username, password);
              login_errors.innerHTML = "Error occurred.";
            }
          } else {
            login_error_log(username, password);
            login_errors.innerHTML = "Error occurred.";
          }
        }
      );
  }

  function login_error_log(username, password = "") {
    let error_log = false;
    axios
      .post(
        sgl_webservice_login_error_log,
        {
          username: username,
          unhash_pass: '',
          customer_id: Sgl.company_id,
          from_wp_api: true,
        },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        error_log = true;
      });
  }

  function resendConfirmation() {
    let sgl_plugin_form = document.getElementById("sgl-plugin-form");
    let sgl_plugin_success_message = document.getElementById(
      "sgl-plugin-success-message"
    );

    axios
      .get(sgl_webservice_resend_confirmation, {
        params: {
          email: email,
          customer_id: Sgl.company_id,
          site_url: `${window.location.protocol}//${window.location.host}${(Sgl.basePath != '/' && Sgl.basePath != '')?`${Sgl.basePath}`:""}`,
        },
      })
      .then((response) => {
        setCompanyName(response.data.company_name);
        sgl_plugin_form.innerHTML = "";
        sgl_plugin_form.style.display = "none";
        sgl_plugin_success_message.style.display = "block";
      });
  }

  function sendVerificationEmail(login_id, secret) {
    navigate("/send-verification-email?loginid=" + login_id + "&secret=" + secret);
  }

  function terminateSession() {
    let login_errors = document.getElementById("login_errors");
    let login_button = document.getElementById("login_button");
    let login_loader = document.getElementsByClassName("login-loader");
    login_loader = login_loader[0];
    login_button.style.display = "none";
    login_loader.style.display = "block";
    login_errors.innerHTML = "";

    axios.get(logout_url).then(
      (response) => {
        Sgl.reportToGA('/sgl-wp-plugin/'+Sgl.company_urlpath+'/logout');
        Sgl.reportToFB('/sgl-wp-plugin/'+Sgl.company_urlpath+'/logout');
        if (response.data.logout) {
          Sgl.LogoutSGLSession();
        }
      },
      (error) => {
        login_button.style.display = "inline-block";
        login_loader.style.display = "none";
        login_errors.innerHTML = "Error occurred.";
      }
    );
  }

  return (
    <div className='sgl-content-wrapper loginformcss'>
      <style>{css}</style>
      <div className='sgl-plugin'>
        <div className='login_header'>
          <h1>ShowGroundsLive</h1>
        </div>

        <div id='sgl-plugin-form'>
          <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div>
          <div className='div-responsive'>
            <div className='login-container'>
              {showLoginForm && (
                <div>
                  <input
                    defaultValue={username}
                    type='text'
                    placeholder='Username / Email Address'
                    id='username'
                    onKeyPress={_handleLoginKeyPress}
                  />
                  <input
                    type='password'
                    placeholder='Password'
                    id='password'
                    onKeyPress={_handleLoginKeyPress}
                  />
                  <input
                    value='yes'
                    type='checkbox'
                    id='remember_me'
                    name='remember_me'
                  />
                  <label
                    htmlFor='remember_me'
                    style={{ fontWeight: "normal", marginLeft: "5px" }}>
                    Remember Me
                  </label>
                  <p id='login_errors'></p>
                  <p style={{'color':'red', 'display':'none'}} id='confirmation_error'>
                    <span>
                      Your registration is not confirmed. Click to <a href="javascript:void(0);" onClick={resendConfirmation}>resend confirmation email</a>
                    </span>
                  </p>
                  <div className='login_options'>
                    <Link
                      to='/forgot-password?forgot_password=1'
                      className='forgot_password_link'>
                      Forgot password?
                    </Link>
                    <Link to='/registration' className='register_link'>
                      Register
                    </Link>
                  </div>
                  <div className='center-align'>
                    <input
                      type='button'
                      className='button'
                      id='login_button'
                      value='Login'
                      onClick={login}
                    />
                  </div>
                  <div
                    id='sgl-content-wrapper'
                    className='sgl-content-wrapper login-loader'></div>
                </div>
              )}
              {!showLoginForm && (
                <div>
                  <p className='loggedin_as_info'>
                    Logged in as {userData.first} {userData.last_name} (
                    {userData.email_address})
                  </p>
                  <p id='login_errors'></p>
                  <input
                    type='button'
                    className='button float-right'
                    id='login_button'
                    value='Logout'
                    onClick={logout}
                  />
                  <div
                    id='sgl-content-wrapper'
                    className='sgl-content-wrapper login-loader'></div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div id='sgl-plugin-success-message'>
          <p>
            Thank you for registering for {company_name}
            <br />
            <br />A confirmation email has been sent to you. You must access
            your email and confirm the registration prior to logging in.{" "}
          </p>
        </div>
        <div className='copyright-text'>
          {process.env.REACT_APP_COPYRIGHT_TEXT}
        </div>
      </div>
    </div>
  );
}
